import {useCallback} from 'react';
import * as React from 'react';
import {TopicModule} from '@/services/pages/channel/channel.client';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import styles from './index.less';


interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

const SelfTopicImgSpecialDoubleColumn = ({infos, page, channelBusinessLine}: Props) => {

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        (linkUrl?: string, swanUrl?: string, card?) => {
            const urlParams = {
                linkUrl,
                swanUrl,
            };
            const logParams = {
                page: page,
                value: 'jump_tupian_teshu',
                channelId: infos?.channelId,
                pageType: channelBusinessLine,
                moduleId: infos?.moduleId,
                moduleName: infos?.moduleName,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: card.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: card.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [
            channelBusinessLine,
            infos.channelId,
            infos.moduleId,
            infos.moduleName,
            page,
            navigateToUrl,
        ]
    );

    const leftSize = 2;

    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_tupian_teshu',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >

            {
                (infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle))
                    ? (
                        <div className={styles.titleParent}>
                            <div className={styles.titleContent}>
                                {
                                    infos.moduleName
                                        ? (
                                            <span className={styles.title}>
                                                {infos.moduleName}
                                            </span>
                                        )
                                        : null
                                }
                                {
                                    infos.moduleSubTitle
                                        ? (
                                            <span className={styles.subTitle}>
                                                {infos.moduleSubTitle}
                                            </span>
                                        )
                                        : null
                                }
                            </div>
                            <div>
                                {
                                    infos?.moreUrl
                                        ? (
                                            <img
                                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                                                className={styles.rightMoreArrow}
                                                onClick={() => {
                                                    handleClick(infos.moreUrl);
                                                }}
                                            />
                                        )
                                        : null
                                }
                            </div>
                        </div>
                    )
                    : null
            }


            <div className={styles.parent}>

                <div className={styles.cardParent}>

                    {
                        infos.itemList?.map(
                            (cardInfo, index) => (
                                index < leftSize
                                    ? (
                                        <div
                                            key={cardInfo.itemId}
                                            className={styles.itemCardParent}
                                            data-show={JSON.stringify({
                                                'page': page,
                                                'value': 'jump_tupian_teshu',
                                                'pageSourceId': cardInfo.channelId,
                                                'pageType': channelBusinessLine,
                                                'valueId': cardInfo.itemId,
                                                'valueTitle': cardInfo.title,
                                                'valueType': VALUE_TYPE.ITEM,
                                            })}
                                        >
                                            <img
                                                src={cardInfo.fieldValue?.img}
                                                className={styles.itemCard}
                                                onClick={
                                                    () => handleClick(
                                                        cardInfo.fieldValue?.link,
                                                        cardInfo.fieldValue?.swanUrl,
                                                        cardInfo
                                                    )
                                                }
                                            />

                                            <div style={{
                                                display: 'grid',
                                                position: 'absolute',
                                                top: 0,
                                            }}
                                            >
                                                <span className={styles.cardTitle}>
                                                    {cardInfo.fieldValue?.title}

                                                </span>

                                                <span className={styles.cardSubTitle}>
                                                    {cardInfo.fieldValue?.subTitle}

                                                </span>

                                            </div>

                                        </div>
                                    )
                                    : null
                            )
                        )
                    }

                </div>

                <div className={styles.subCardParent}>

                    {
                        infos.itemList?.map(
                            (cardInfo, index) => (
                                index >= leftSize && index < 5
                                    ? (
                                        <div
                                            key={cardInfo.itemId}
                                            onClick={
                                                // eslint-disable-next-line max-len
                                                () => handleClick(cardInfo?.fieldValue?.link, cardInfo.fieldValue?.swanUrl, cardInfo)
                                            }
                                            className={styles.subCard}
                                            data-show={JSON.stringify({
                                                'page': page,
                                                'value': 'jump_tupian_teshu',
                                                'pageSourceId': cardInfo.channelId,
                                                'pageType': channelBusinessLine,
                                                'valueId': cardInfo.itemId,
                                                'valueTitle': cardInfo.title,
                                                'valueType': VALUE_TYPE.ITEM,
                                            })}
                                        >
                                            <div className={styles.subCardItem}>
                                                <img
                                                    src={cardInfo?.fieldValue?.img}
                                                    className={styles.subCardIcon}
                                                />

                                                <div className={styles.cardTitleContent}>

                                                    <span
                                                        className={styles.subCardTitle}
                                                    >
                                                        {cardInfo.fieldValue?.title}
                                                    </span>

                                                    <span
                                                        className={styles.subCardSubTitle}
                                                    >
                                                        {cardInfo.fieldValue?.subTitle}
                                                    </span>

                                                </div>

                                            </div>

                                            {
                                                index < (infos.itemList?.length || 0) - 1
                                                    ? <div className={styles.line} />
                                                    : null

                                            }

                                        </div>
                                    )
                                    : null
                            )
                        )
                    }

                </div>

            </div>

        </div>
    );
};

export default SelfTopicImgSpecialDoubleColumn;
